import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=f6ff2172&"
import script from "./createModal.vue?vue&type=script&lang=js&"
export * from "./createModal.vue?vue&type=script&lang=js&"
import style0 from "./createModal.vue?vue&type=style&index=0&id=f6ff2172&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports